import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material"
import React, { Fragment, useEffect, useRef, useState } from "react"
import stopImgIcon from "../../images/no-trips.png"
import startedImgIcon from "../../images/service-started.png"
import successImgIcon from "../../images/payment-success.png"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { FaCopy } from "react-icons/fa6"

interface props {
  genrateOtp: () => void
  otpFill: string
  isloadingShow: boolean
  generateOtp: { activeJobflow: string }
  handleOtpgeanerate: (value: string) => void
}
const GenRateotpCustomer = ({
  genrateOtp,
  otpFill,
  isloadingShow,
  generateOtp,
  handleOtpgeanerate,
}: props) => {
  const [otp, setOtp] = useState(Array(6).fill(""))
  const inputRefs = useRef<(HTMLInputElement | null)[]>([])

  const handleChange = (index: number, value: string) => {
    // Only digits
    const numericValue = value.replace(/\D/g, "").slice(0, 1)

    const newOtp = [...otp]
    newOtp[index] = numericValue
    setOtp(newOtp)

    if (handleOtpgeanerate) {
      handleOtpgeanerate(newOtp.join(""))
    }

    // Move focus to next input
    if (numericValue !== "" && index < 5) {
      inputRefs.current[index + 1]?.focus()
    }
  }

  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus()
    }
  }

  const handlePaste = (e: React.ClipboardEvent) => {
    e.preventDefault()
    const data = e.clipboardData.getData("text")
    const numericData = data.replace(/\D/g, "").slice(0, 6)

    if (numericData.length > 0) {
      const newOtp = numericData.split("").concat(Array(6 - numericData.length).fill(""))
      setOtp(newOtp)
      if (handleOtpgeanerate) {
        handleOtpgeanerate(newOtp.join(""))
      }

      // Focus the last filled input or the next one
      const nextIndex = Math.min(numericData.length, 5)
      inputRefs.current[nextIndex]?.focus()
    }
  }

  const handleCopy = () => {
    const fullOtp = otp.join("")
    if (fullOtp.length > 0) {
      navigator.clipboard.writeText(fullOtp)
      toast.success("Code Copied to Clipboard", { autoClose: 1000 })
    }
  }

  useEffect(() => {
    if (!otpFill) {
      setOtp(Array(6).fill(""))
    } else {
      setOtp(otpFill.split("").concat(Array(6 - otpFill.length).fill("")))
    }
  }, [otpFill])

  useEffect(() => {
    if (generateOtp?.activeJobflow == "STOP_SERVICE") {
      handleOtpgeanerate("")
    }
  }, [generateOtp?.activeJobflow])


  const hasExistingOtp = !!otpFill;

  return (
    <Box>
      <Typography
        align="left"
        variant="h2"
        className="fw-medium font-24 generate-code-title"
        mb={1}
      >
        {hasExistingOtp ? "Code Generated" : "Generate Code"}
      </Typography>
      {(generateOtp?.activeJobflow == "JOB_ACTIVE" ||
        generateOtp?.activeJobflow == "STOP_SERVICE" ||
        generateOtp?.activeJobflow == "CUSTOMER_STOP_OTP") && (
          <Grid container spacing={2}>
            <Grid item xs={12} lg={7}>
              <Box className="otp-box text-center otp-box-1 generate-code-highlight">
                <Box pb={3}>
                  <FormControl className="d-flex justify-content-center gap-3 flex-row">
                    {otp?.map((digit, index) => (
                      <input
                        key={index}
                        ref={(el) => (inputRefs.current[index] = el)}
                        type="text"
                        value={digit}
                        onChange={(e) => handleChange(index, e.target.value)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                        onPaste={handlePaste}
                        className="otp-boxes"
                        maxLength={1}
                        inputMode="numeric"
                        required
                        style={{
                          pointerEvents: "auto",
                        }}
                      />
                    ))}
                  </FormControl>
                  {/* {hasExistingOtp && (
                    <Tooltip title="Copy OTP" arrow>
                      <IconButton 
                        onClick={handleCopy} 
                        sx={{ 
                          color: "#F475A4", 
                          ml: 1,
                          "&:hover": { backgroundColor: "rgba(244, 117, 164, 0.08)" } 
                        }}
                      >
                        <FaCopy size={20} />
                      </IconButton>
                    </Tooltip>
                  )} */}
                </Box>
                {hasExistingOtp ? (
                  <Box>
                    <Typography sx={{ fontSize: "14px", color: "#555", fontWeight: 500, mt: 1 }}>
                      Please Share This Code With The Provider
                    </Typography>
                    <Button
                      variant="text"
                      onClick={handleCopy}
                      startIcon={<FaCopy />}
                      sx={{
                        color: "#F475A4",
                        mt: 0.5,
                        textTransform: "capitalize",
                        fontSize: "14px",
                        fontWeight: 600,
                        "&:hover": { backgroundColor: "transparent", textDecoration: "underline" },
                      }}
                    >
                      Copy Code
                    </Button>
                  </Box>
                ) : (
                  <Button
                    className="view-profile py-2 text-capitalize"
                    style={{ minWidth: "118px" }}
                    onClick={genrateOtp}
                  >
                    {isloadingShow ? (
                      <Typography fontSize={1}>
                        <CircularProgress
                          style={{ color: "pink", fontSize: 20 }}
                          size={20}
                        />
                      </Typography>
                    ) : (
                      "Generate Code"
                    )}
                  </Button>
                )}
              </Box>
            </Grid>
            <Grid item xs={12} lg={5} className="d-none d-xl-block m-auto">
              <Box
                sx={{
                  maxWidth: 300,
                  height: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={stopImgIcon}
                  alt="Description"
                  style={{ width: "200px", height: "auto" }}
                />
              </Box>{" "}
            </Grid>
          </Grid>
        )}
    </Box>
  )
}
export default GenRateotpCustomer

interface propsServiceStart {
  isloadingShow: boolean
  blankOtp: (value: string) => void
  serviceStop: () => void

  postDetails: { activeJobflow: string }
}

const ServiceStart = ({
  isloadingShow,
  blankOtp,
  serviceStop,
  postDetails,
}: propsServiceStart) => {
  useEffect(() => {
    blankOtp("")
  }, [])
  return (
    <>
      {postDetails?.activeJobflow == "START_OTP_VERIFIED" && (
        <Fragment>
          <Typography
            align="left"
            variant="h2"
            className=" fw-medium font-24"
            mb={1}
          >
            Code Generated{" "}
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={7}>
              <Box
                className="otp-box h-100 text-center d-flex flex-column align-items-center justify-content-center"
                sx={{ mt: 1 }}
              >
                <Typography
                  align="center"
                  variant="body1"
                  className="green-heading p-4"
                  mb={2}
                >
                  Your Service Has Started{" "}
                </Typography>

                <Button
                  className="view-profile py-2 text-capitalize"
                  onClick={serviceStop}
                >
                  {isloadingShow ? (
                    <Typography fontSize={1}>
                      <CircularProgress
                        style={{ color: "pink", fontSize: 20 }}
                        size={20}
                      />
                    </Typography>
                  ) : (
                    "Stop Service"
                  )}
                </Button>
              </Box>{" "}
            </Grid>
            <Grid item xs={12} lg={5} className="d-none d-xl-block m-auto">
              <Box
                sx={{
                  maxWidth: 300,
                  height: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={startedImgIcon}
                  alt="Description"
                  style={{ width: "200px", height: "auto" }}
                />
              </Box>{" "}
            </Grid>
          </Grid>
          <Box className="d-flex gap-1 justify-content-between "></Box>
        </Fragment>
      )}
    </>
  )
}

export { ServiceStart }

interface propsPay {
  handlePayment: () => void
  postDetailsForPay: {
    activeJobflow: string
    paymentDetail: { totalAmount: number }
    data: {
      activeJobflow: string
      _id: string  // Booking ID
      assignedTo?: Array<{ _id: string }>  // Provider ID array
      rating?: any
    }
  }
}

const PayPriceForService = ({ handlePayment, postDetailsForPay }: propsPay) => {
  const navigate = useNavigate();

  const handleWriteReview = () => {
    const bookingId = postDetailsForPay?.data?._id;
    const providerId = postDetailsForPay?.data?.assignedTo?.[0]?._id;

    if (bookingId && providerId) {
      if (postDetailsForPay?.data?.rating) {
        navigate(`/dashboard/rating-reviews`);
      } else {
        navigate(`/dashboard/write-review/${bookingId}?postId=${providerId}`);
      }
    } else {
      handlePayment();
    }
  };

  return (
    <>
      {postDetailsForPay?.data?.activeJobflow == "END_OTP_VERIFIED" && (
        <Fragment>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={7}>
              <Box className="otp-box text-center otp-box-1">
                <>
                  <Box pb={1}>
                    {" "}
                    <p
                      style={{
                        textAlign: "center",
                        fontSize: "20px",
                        color: "#000",
                        fontWeight: "600",
                      }}
                    >
                      {postDetailsForPay?.data?.rating ? "View Review for your Service Provider" : "Write a Review for your Service Provider"}
                      <span style={{ color: "#009C35" }}>
                        {" "}
                        {/* C${postDetailsForPay?.paymentDetail?.totalAmount} */}
                      </span>{" "}
                    </p>
                  </Box>
                  <Button
                    className="view-profile py-2 text-capitalize"
                    style={{ minWidth: "118px" }}
                    onClick={handleWriteReview}
                  >
                    {postDetailsForPay?.data?.rating ? "View Review" : "Write Review"}
                  </Button>
                </>
              </Box>
            </Grid>
            <Grid item xs={12} lg={5} className="d-none d-xl-block m-auto">
              <Box>
                <Typography
                  align="center"
                  variant="h2"
                  className=" fw-medium font-24"
                  mb={1}
                >
                  Service Completed Successfully!
                </Typography>
              </Box>
              <Box
                sx={{
                  height: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={successImgIcon}
                  alt="Description"
                  style={{ width: "110px", height: "auto", marginTop: "20px" }}
                />
              </Box>{" "}
            </Grid>
          </Grid>
        </Fragment>
      )}
    </>
  )
}

export { PayPriceForService }
